import * as React from 'react';
import Modal from 'antd/lib/modal';
import './Dialog.scss';

export interface IDialogProps {
	open: boolean;
	children: React.ReactElement;
	onClose: () => void;
}

const Dialog = (props: IDialogProps) => <Modal
	width={400}
	footer={false}
	visible={props.open}
	className="Dialog"
	onCancel={props.onClose}>
	<div className="Dialog-Content">
		{props.children}
	</div>
</Modal>


export default Dialog;
